import React from 'react';
import { X } from 'lucide-react';
import '../styles/modal.css';

const DataModal = ({ isOpen, onClose, data, title }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content data-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="modal-close" onClick={onClose}>
            <X size={24} />
          </button>
        </div>
        
        <div className="modal-body">
          {data?.events && data.events.length > 0 ? (
            <div className="data-modal-section">
              <h3>Activity Details</h3>
              <div className="data-modal-stats">
                <div className="stat-item">
                  <span className="stat-label">Total Events:</span>
                  <span className="stat-value">{data.events.length}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label">Clicks:</span>
                  <span className="stat-value">{data.clicks || 0}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label">Leads Captured:</span>
                  <span className="stat-value">{data.leads || 0}</span>
                </div>
              </div>
              
              <div className="events-breakdown">
                <h4>Events Timeline</h4>
                <div className="event-list">
                  {data.events.map((event, idx) => (
                    <div key={idx} className="event-item">
                      <div className="event-badge" data-type={event.event}>
                        {event.event.replace('_', ' ')}
                      </div>
                      <div className="event-details">
                        <div className="event-label">{event.label || 'Unknown'}</div>
                        <div className="event-time">
                          {new Date(event.timestamp).toLocaleTimeString()}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : (
            <div className="no-data-message">
              <p>No events recorded for this date.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DataModal;
